<script>
	import ContactWithDoB from "../../components/ContactWithDoB.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { anonymousId } from "../../analytics";
	import { pageNumber, model } from "../../stores";
	import { referralTypes } from "../../config";

	import { getTealiumID } from "../../tealium";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	let required = true;

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		if (typeof window !== "undefined" && window.analytics && window.analytics.user) {
			$model.RegistrationSegmentId = anonymousId();
		}

		$model.TealiumId = getTealiumID();
	}

	const initialise = () => {
		console.log($model);
	};

	initialise();
</script>

<PageSection>
	<h2>Your Contact Details</h2>

	<ContactWithDoB
		bind:title={$model.Contact.Title}
		bind:firstName={$model.Contact.FirstName}
		bind:surname={$model.Contact.Surname}
		bind:dateOfBirth={$model.Contact.DateOfBirth}
		bind:emailAddress={$model.Contact.EmailAddress}
		bind:phoneNumber={$model.Contact.PhoneNumber}
		bind:address={$model.Contact.Address}
		idPrefix="contact"
		{required}
		{disabled}
	></ContactWithDoB>

	<FormRow>
		<FormColumn>
			<label for="whereDidYouHear" class:isrequired={required}>Where did you hear about our firm?</label>
			<Select
				{required}
				{disabled}
				id="whereDidYouHear"
				bind:value={$model.WhereDidYouHear}
				optionList={referralTypes}
				textProperty="name"
				valueProperty="name"
			></Select>
		</FormColumn>
	</FormRow>

	<FormRow>
		<div class="col-md-8 col-sm-12">
			<Checkbox
				{disabled}
				required="true"
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the Shine Lawyers <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>"
				id="privacy"
			></Checkbox>
		</div>
	</FormRow>

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} pageName={title} tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</PageSection>

<style>
</style>
